import type { CohortRow, TrendPoint } from '@paige/ui';
import type { RetentionCohort, RetentionWeek } from '../types';

/** "W0", "W1" …: the column headings, one per week the oldest cohort could have reached. */
export function weekHeadings(weeks: number): string[] {
  return Array.from({ length: weeks }, (_, i) => `W${i}`);
}

/**
 * One grid row per sign-up week: the share of the cohort active in each week since, undefined
 * past the weeks it has reached, and nothing at all for a week nobody signed up in.
 */
export function cohortRows(
  cohorts: readonly RetentionCohort[],
  weeks: number,
  label: (week: string) => string,
): CohortRow[] {
  return cohorts.map((c) => ({
    label: label(c.week),
    size: c.size,
    shares: Array.from({ length: weeks }, (_, i) =>
      c.size > 0 && i < c.active.length ? (c.active[i] ?? 0) / c.size : undefined,
    ),
  }));
}

/** The weekly line for companies or people, the week N earlier as the ghost. */
export function weeklyPoints(
  weekly: readonly RetentionWeek[],
  what: 'companies' | 'people',
  label: (week: string) => string,
): TrendPoint[] {
  return weekly.map((w) => ({
    label: label(w.week),
    value: w[what],
    previous: what === 'companies' ? w.previousCompanies : w.previousPeople,
  }));
}

/** "3 weeks", "1 week". */
export function weeksWord(n: number): string {
  return `${n} ${n === 1 ? 'week' : 'weeks'}`;
}
